var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #1e5288;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(-972.5 -5339.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    className: "cls-1",
    width: 77,
    height: 77,
    transform: "translate(973.5 5340.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-2",
    d: "M211.388,326.767l37.5-37.107,37.5,37.107L249.74,364.66Z",
    transform: "translate(763.249 5051.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    className: "cls-1",
    width: 60,
    height: 60,
    transform: "translate(981.5 5348.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.2ed5fa4c03fb4f200f475328d0430186.svg";
export { ForwardRef as ReactComponent };